import React from 'react';
import '../styles/components/confirmDelete.css';

export type ConfirmDeleteProps = {
  isOpen: boolean;
  title?: string;
  message?: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  isSubmitting?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ConfirmDelete: React.FC<ConfirmDeleteProps> = ({
  isOpen,
  title = 'Xác nhận xóa',
  message = 'Bạn có chắc chắn muốn xóa mục này? Hành động này không thể hoàn tác.',
  confirmText = 'Xóa',
  cancelText = 'Hủy',
  isSubmitting = false,
  onConfirm,
  onCancel,
}) => {
  React.useEffect(() => {
    if (!isOpen) return;

    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel();
    };

    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div className="cd-overlay" onClick={onCancel}>
      <div className="cd-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="cd-title">
        <div className="cd-header">
          <h3 id="cd-title">{title}</h3>
        </div>
        <div className="cd-body">
          {typeof message === 'string' ? <p>{message}</p> : message}
        </div>
        <div className="cd-footer">
          <button className="cd-btn cd-btn-secondary" onClick={onCancel} disabled={isSubmitting}>
            {cancelText}
          </button>
          <button className="cd-btn cd-btn-danger" onClick={onConfirm} disabled={isSubmitting}>
            {isSubmitting ? 'Đang xóa...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDelete;


